import { getLocale } from "../runtime";

const sv_frcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `France`
};

const frcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_frcountryenglish(inputs)
	return "frCountryEnglish";
};

export { frcountryenglish as "frCountryEnglish" };